import { makeStyles } from '@material-ui/styles';
import {
    white,
    silver,
    doveGray,
    royalblue,
    dustyGray,
} from '../../../constants/Colors';

export default makeStyles((theme) => ({
    container: {
        position: 'relative',
    },
    clearIcon: {
        position: 'absolute',
        top: '52%',
        right: 20,
        transform: 'translate(0, -50%)',
        padding: 10,
        cursor: 'pointer',
        color: doveGray,
        zIndex: 1,
    },
    searchIcon: {
        position: 'absolute',
        top: '52%',
        left: 5,
        transform: 'translate(0, -50%)',
        padding: 10,
        cursor: 'pointer',
        color: doveGray,
        zIndex: 1,
        fontSize: '1.15rem',
    },
    input: {
        minHeight: 36,
        paddingLeft: 42,
        backgroundColor: white,
        border: `1px solid ${silver}`,
        borderRadius: 3,
        fontSize: '0.94rem',
        width: 150,

        '&::placeholder': {
            color: dustyGray,
        },

        '&:focus': {
            border: `1px solid ${royalblue}`,
            outline: 'none',
        },
    },
}));
